module.exports = __webpack_public_path__ + "img/ryimg.fc5d8660.png";